import React from 'react';
import './MosollaSpeciality.css'
import { FaHandPointRight } from "react-icons/fa6";

const MosollaSpeciality = () => {
    return (
        <div className='mosollaspeciallyConainer'>
            <p className='mosollaspecailP'>আমাদের মসলার বৈশিষ্ট্যসমূহ</p>



            <div className='MosollaCtgParent'>


                <div className='mspparent'>
                    <div className='mspchild'>
                        <FaHandPointRight className='mosolaRgiht' />  <p>মরিচের গুঁড়া</p>
                    </div>
                    <p className='mspparentDescription'>লাল মরিচ গুঁড়া রঙ ও ঝালে সমৃদ্ধ, রান্নায় এনে দেবে আসল স্বাদ</p>
                    <div className='chilmosoolalast'>
                        <p>200gm container</p>
                        <p>500gm container</p>
                    </div>
                </div>

                <div className='mspparent'>
                    <div className='mspchild'>
                        <FaHandPointRight className='mosolaRgiht' />  <p>হলুদের গুঁড়া</p>
                    </div>
                    <p className='mspparentDescription'>হলুদ গুঁড়া বিশুদ্ধ হলুদ থেকে তৈরি, প্রাকৃতিক রং ও গন্ধ</p>
                    <div className='chilmosoolalast'>
                        <p>200gm container</p>
                        <p>500gm container</p>
                    </div>
                </div>


                <div className='mspparent'>
                    <div className='mspchild'>
                        <FaHandPointRight className='mosolaRgiht' />  <p>ধনিয়ার গুঁড়া</p>
                    </div>
                    <p className='mspparentDescription'>ধনিয়া গুঁড়া প্রিমিয়াম মানের ধনিয়া, স্বাদে আলাদা</p>
                    <div className='chilmosoolalast'>
                        <p>200gm container</p>
                        <p>500gm container</p>
                    </div>
                </div>

                <div className='mspparent'>
                    <div className='mspchild'>
                        <FaHandPointRight className='mosolaRgiht' />  <p>জিরার গুঁড়া</p>
                    </div>
                    <p className='mspparentDescription'>জিরা গুঁড়া তাজা জিরা থেকে প্রস্তুত, ঘ্রাণে ভরপুর</p>
                    <div className='chilmosoolalast'>
                        <p>200gm container</p>
                        <p>500gm container</p>
                    </div>
                </div>



            </div>

        </div>
    );
};

export default MosollaSpeciality;